import * as React from 'react'
import loadable from '@loadable/component'
import Props from './props'
import i18n from 'src/assets/messages'
const Text = loadable(() => import('src/presentations/elements/Text'))

export default class Loader extends React.Component<Props> {
  render() {
    return (
      <div className={`fullLoader ${this.props.className || ''}`}>
        <div className="load">
          <div className={`loader ${this.props.size || ''}`} />
          {this.props.text !== false && (
            <Text className={'loadText'} useWordBoundary={50}>
             {`${i18n.t(this.props.textLabel || 'loading')}${this.props.points === false ? '' : '...'}`}
            </Text>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/presentations/widgets/Loader/index.tsx